/* eslint-disable eqeqeq */
import http from '../../Utils/http';

const RestrictInvoices = {
    name: 'restrictInvoices',
    state: {
        isRestricted: false,
    },
    reducers: {
        inialized(state) {
            return {
                isRestricted: false,
            };
        },
        received(state, payload) {
            return { ...state, isRestricted: payload };
        },
    },
    effects: (dispatch) => ({
        async restrictFromReceivingNotifications(id) {
            this.inialized();
            const response = await http.put(
                `savvy/users/restrictInvoices/${id}`
            );
            await this.received(response.data.data);
        },
    }),
};

export default RestrictInvoices;
